import { CIC_FEE_REASONS_ACTION_TYPE } from '../actions';

const initialState = {};

const cicFeeReasonSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CIC_FEE_REASONS_ACTION_TYPE.GET_CIC_REASONS_SCHEMA:
      return payload || state;

    default:
      return state;
  }
};

export default cicFeeReasonSchemaReducer;
